import { Button, Result } from 'antd';
import { t } from 'i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';

export default function NoPermission() {
  const history = useHistory();
  return (
    <div>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => history.push('/')}>
            {t('Back Home')}
          </Button>
        }
      />
    </div>
  );
}
